// extracted by mini-css-extract-plugin
module.exports = {"container":"SiteFooter_container__2Pdmj"};